import { Tooltip, useTheme } from "@mui/material";
import LockIcon from "assets/icon/LockIcon";
import useLocales from "hooks/useLocales";

const PermissionInfo = ({ disableDimentions = false }) => {
  const theme = useTheme();
  const { translate } = useLocales();
  return (
    <Tooltip title={translate("you_dont_have_permission_to_access_this_page")}>
      <span>
        <LockIcon
          height={15}
          width={15}
          customColor={theme.palette.primary.dark}
          disableDimentions={disableDimentions}
        />
      </span>
    </Tooltip>
  );
};
export default PermissionInfo;
